import { create } from "zustand";

export const usePanelSimpleStore = create((set, get) => ({
  drawers: {
    icon: false,
  },
  setDrawers: (value) =>
    set((state) => ({
      ...state,
      drawers: { ...state.drawers, ...value },
    })),

  data: {},
  setData: (value, isUndo = false, isRedo = false) => {
    const currentData = get().data;
    const newData = { ...currentData, ...value };

    if (!isUndo && !isRedo) {
      get().pushToHistory(newData);
    }

    set(() => ({
      data: newData,
    }));
  },

  getData: () => get().data,

  position: 0,
  updatePosition: (value) => {
    set(() => ({
      position: value,
    }));
  },

  history: [],
  pushToHistory: (value) => {
    const newHistory = [...get().history, value];

    set(() => ({
      history: newHistory,
      position: newHistory.length - 1,
    }));
  },

  undo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position - 1],
      },
      true,
      false
    );
    set({ position: position - 1 });
  },
  redo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position + 1],
      },
      false,
      true
    );
    set({ position: position + 1 });
  },

  canUndo: () => {
    const { position } = get();
    return position > 0;
  },
  canRedo: () => {
    const { history, position } = get();
    return position < history.length - 1;
  },

  resetStore: () => {
    set({
      data: {},
      position: 0,
      history: [],
    });
  },
}));

/*

  data - current data set, which is used in the editor
  setData - function to set data, coming from the editor, and push to history if it is not undo or redo

  position - current position in the history array
  updatePosition - function to update position

  history - array of all the data that has been set
  pushToHistory - function to push data to history

  undo - function to undo and set data to previous value in history
  redo - function to redo and set data to next value in history


*/
